export const REQUIRE_FEE_DISPLAY_STATES = ['ca', 'mn'];

export default {
  REQUIRE_FEE_DISPLAY_STATES,
};
